'use client';
import { accordionContentClass } from './Accordion.css';
import React, { useEffect, useState } from 'react';
export const AccordionRoot = ({ children, linked = false, initialOpenSection = undefined, }) => {
    const [openSections, setOpenSections] = useState([initialOpenSection]);
    useEffect(() => {
        if (linked && openSections.length > 1) {
            const lastOpen = openSections.pop() || undefined;
            setOpenSections([lastOpen]);
        }
    }, [linked]);
    return (React.createElement("div", { "data-testid": "kda-accordion-sections" }, React.Children.map(children, (section, sectionIndex) => React.cloneElement(section, {
        index: sectionIndex,
        isOpen: openSections.includes(sectionIndex),
        className: accordionContentClass,
        onClick: () => openSections.includes(sectionIndex)
            ? setOpenSections(openSections.filter((i) => i !== sectionIndex))
            : setOpenSections(linked ? [sectionIndex] : [...openSections, sectionIndex]),
    }))));
};
//# sourceMappingURL=Accordion.js.map